import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import swal from "sweetalert";
// import PromotionModal from "./modal/promotion";
// import modalStatus from "./modal/update";
import { useLocation, useNavigate, Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGraduate,
  faMagnifyingGlass,
  faPlus,
  faPen,
  faDownload,
  faFileImport
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ModalStatus from "./modal/status";
import PreviewFoto, { StudentAvatar, studentPhoto } from "./modal/preview-foto";
import StudentDetailModal from "./modal/detail-siswa";
import ImportExcelModal, { downloadStudentExcel, commitImportedStudents } from "./modal/import-excel";
import FotoProfilTab from "./foto-profil";
import KartuPelajarTab from "./kartu-pelajar";
import TambahSiswaModal from "./modal/tambah-siswa";


const formatJenisKelamin = (value) => {
  const label = String(value ?? "").trim();
  const code = label.toUpperCase();
  if (code === "P") return "Perempuan";
  if (code === "L") return "Laki-Laki";
  return label || "-";
};

export default function KonfigurasiSiswa() {
  document.title = "KonfigurasiSiswa";

  const [successToast, setSuccessToast] = useState("");
    useEffect(() => {
      if (!successToast) return;
      const timer = setTimeout(() => setSuccessToast(""), 3000);
      return () => clearTimeout(timer);
    }, [successToast]);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const [id, setId] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [, setGetDataTeacher] = useState([]);

  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [getData, setGetData] = useState([]);
  const [dataWalas, setDataWalas] = useState(null);
  const [previewStudent, setPreviewStudent] = useState(null);
  const [detailStudent, setDetailStudent] = useState(null);
  const [statusStudent, setStatusStudent] = useState(null);
  const [studentStatuses, setStudentStatuses] = useState({});
  const [semesterDataCache, setSemesterDataCache] = useState({});
  const requestSequence = useRef(0);

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState("siswa");
  const [showImportModal, setShowImportModal] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const yearOptions = useMemo(() => {
    const years = new Map();
    getDataSemesterMap.forEach((semester) => {
      if (!years.has(semester?.name_year)) {
        years.set(semester?.name_year, { name: semester?.name_year, active: false });
      }
      if (semester?.status === 1) years.get(semester.name_year).active = true;
    });
    return [...years.values()].filter((year) => year.name).sort((a, b) =>
      String(b.name).localeCompare(String(a.name), "id", { numeric: true })
    );
  }, [getDataSemesterMap]);
  const semesterOptions = useMemo(() =>
    getDataSemesterMap.filter((semester) => semester?.name_year === namaTA)
      .sort((a, b) => Number(a.semester) - Number(b.semester)),
    [getDataSemesterMap, namaTA]
  );

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
    ysb_teacher_id: "",
  });

  const location = useLocation();

  const [, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
    } else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate, setPermission]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((controller) => controller.abort());
    };
  }, []);

  const collator = useMemo(
    () =>
      new Intl.Collator("id", {
        numeric: true,
        sensitivity: "base",
      }),
    []
  );

  const safeStr = (value) =>
    value === null || value === undefined ? "" : String(value);

  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((jenjang) =>
        (a.school_name || "").toUpperCase().includes(jenjang)
      );

      const jenjangB = order.findIndex((jenjang) =>
        (b.school_name || "").toUpperCase().includes(jenjang)
      );

      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter(
        (school) => school.school_code !== "BASEMENT_BEKASI"
      );
    }

    return schools;
  };

  const fetchInit = useCallback(async () => {
    setLoading(true);

    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
      ]);

      if (!isMounted.current) {
        return;
      }

      if (branchRes?.status === 200) {
        const branches = branchRes?.data?.data || [];

        setGetDataBranch(branches);

        if (branches.length > 0) {
          const firstBranch = branches[0]?.branch_code;

          setForm2((previous) => ({
            ...previous,
            ysb_branch_id: firstBranch,
          }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes?.data?.data || [];
        const active =
          semesters.find((semester) => semester?.status === 1) || semesters[0];

        setGetDataSemesterMap(semesters);

        if (active) {
          setNamaTA(active?.name_year || "");

          setForm2((previous) => ({
            ...previous,
            ysb_semester_id: active?.id,
          }));
        }
      }

    } catch (error) {
      swal({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Terjadi kesalahan",
        icon: "error",
      });
    }
  }, [
    ascending,
    descending,
    fetchParams,
    keyword,
    limit,
    page,
    storageBranchGroping,
    storageLevel,
    setGetDataDimensi,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingSchool(true);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools = response?.data?.data || [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter(
              (school) => school?.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setGetDataLevel([]);
            setGetDataKelas([]);

            setForm2((previous) => ({
              ...previous,
              ysb_school_id: schools[0]?.school_code,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setGetDataKelas([]);

            setForm2((previous) => ({
              ...previous,
              ysb_school_id: "",
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));

            setGetDataTeacher([]);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [
      ascending,
      fetchParams,
      limit,
      page,
      storageLevel,
      setGetDataTeacher,
    ]
  );

  useEffect(() => {
    if (form2?.ysb_branch_id) {
      fetchSchoolsByBranch(form2.ysb_branch_id);
    }
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare(b?.name_level || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const sortKelas = (classes) => {
    return [...classes].sort((a, b) =>
      (a?.name_kelas || "").localeCompare(b?.name_kelas || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;
      initKelasDone.current = false;

      if (!schoolId) {
        return;
      }

      setLoadingLevel(true);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let levels = response?.data?.data || [];

          levels = levels.filter(
            (level) => level?.ysb_school_id === schoolId
          );

          if (branchId) {
            levels = levels.filter(
              (level) => level?.ysb_branch_id === branchId
            );
          }

          levels = sortLevels(levels);

          setGetDataLevel(levels);

          if (levels.length === 0) {
            initKelasDone.current = true;
          }

          if (levels.length > 0) {
            setForm2((previous) => ({
              ...previous,
              ysb_grade_level_id: levels[0]?.id,
            }));
          } else {
            setForm2((previous) => ({
              ...previous,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
            }));

            setGetDataKelas([]);
          }
        }
      } catch (error) {
        console.error(error);

        swal({
          title: "Failed",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (!form2?.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    setGetDataLevel([]);
    setGetDataKelas([]);

    setForm2((previous) => ({
      ...previous,
      ysb_grade_level_id: "",
      ysb_kelas_id: "",
    }));

    fetchLevelsBySchool(
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchLevelsBySchool,
  ]);

  const fetchKelasByLevel = useCallback(
    async (gradeLevelId, schoolId, branchId) => {
      initKelasDone.current = false;

      if (!gradeLevelId) {
        return;
      }

      setLoadingKelas(true);

      try {
        const response = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let classes = response?.data?.data || [];

          classes = classes.filter(
            (item) => item?.ysb_grade_level_id === gradeLevelId
          );

          if (schoolId) {
            classes = classes.filter(
              (item) => item?.ysb_school_id === schoolId
            );
          }

          if (branchId) {
            classes = classes.filter(
              (item) => item?.ysb_branch_id === branchId
            );
          }

          classes = sortKelas(classes);

          setGetDataKelas(classes);

          if (classes.length > 0) {
            setForm2((previous) => ({
              ...previous,
              ysb_kelas_id: classes[0]?.id,
            }));
          } else {
            setForm2((previous) => ({
              ...previous,
              ysb_kelas_id: "",
            }));
          }
        }
      } catch (error) {
        console.error(error);

        swal({
          title: "Failed",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_kelas_id: "",
        }));
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    },
    [
      ascending,
      fetchParams,
      limit,
      page,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2?.ysb_grade_level_id) {
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_kelas_id: "",
      }));

      return;
    }

    setGetDataKelas([]);

    setForm2((previous) => ({
      ...previous,
      ysb_kelas_id: "",
    }));

    fetchKelasByLevel(
      form2.ysb_grade_level_id,
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_grade_level_id,
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchKelasByLevel,
  ]);

  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_grade_level_id &&
    !!form2.ysb_kelas_id &&
    !loadingSchool &&
    !loadingLevel &&
    !loadingKelas;

  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_kelas_id
    ) {
      return;
    }

    const sequence = ++requestSequence.current;
    const currentSemesters = getDataSemesterMap.filter(
      (semester) => semester?.name_year === namaTA
    );

    try {
      const results = await Promise.all(currentSemesters.map(async (semester) => {
        const response = await APISD.get("/api/student-kelas", {
          params: {
            ysb_academic_year_id: semester.ysb_academic_year_id || semester.ysb_academic_year || semester.academic_year_id,
            ysb_semester_id: semester.id,
            ysb_grade_level_id: form2.ysb_grade_level_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_kelas_id: form2.ysb_kelas_id,
          },
          ...fetchParams,
        });
        if (response?.data?.error) throw new Error(response.data.message);
        const groups = Array.isArray(response?.data?.data) ? response.data.data : [];
        const group = groups.find((item) => String(item.ysb_kelas_id) === String(form2.ysb_kelas_id)) || {};
        return [String(semester.id), { ...group, students: (group.students || []).map((student) => ({ ...student, nama_siswa: student.nama_lengkap || student.nama_siswa || "" })) }];
      }));
      if (sequence !== requestSequence.current) return;
      const cache = Object.fromEntries(results);
      setSemesterDataCache(cache);
      const selected = cache[String(form2.ysb_semester_id)] || {};
      setDataWalas(selected);
      setGetData(Array.isArray(selected.students) ? selected.students : []);
    } catch (error) {
      if (sequence !== requestSequence.current) return;
      setSemesterDataCache({});
      setGetData([]);
      setDataWalas(null);

      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data murid",
        icon: "error",
      });
    }
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_kelas_id,
    form2.ysb_grade_level_id,
    fetchParams,
    getDataSemesterMap,
    namaTA,
  ]);

  useEffect(() => {
    const schoolReady =
      initSchoolDone.current &&
      !loadingSchool &&
      !!form2.ysb_school_id;

    const gradeReady =
      initLevelDone.current &&
      !loadingLevel &&
      !!form2.ysb_grade_level_id;

    const kelasReady =
      initKelasDone.current &&
      !loadingKelas &&
      !!form2.ysb_kelas_id;

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !schoolReady ||
      !gradeReady ||
      !kelasReady
    ) {
      return;
    }

    firstLoadDone.current = true;

    const loadInitialData = async () => {
      setIsFetching(true);

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
      } finally {
        setIsFetching(false);
      }
    };

    loadInitialData();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
    GetResponseData,
  ]);

  // GET ulang hanya data siswa pada semester/kelas aktif setelah simpan/hapus foto.
  // Cache semester lain tetap digunakan agar pindah tab/semester tidak menambah GET.
  const refreshFotoProfil = useCallback(async () => {
    const semester = getDataSemesterMap.find(
      (item) => String(item?.id) === String(form2.ysb_semester_id)
    );
    if (!semester) throw new Error("Data semester tidak ditemukan.");

    const sequence = ++requestSequence.current;
    const response = await APISD.get("/api/student-kelas", {
      params: {
        ysb_academic_year_id: semester.ysb_academic_year_id || semester.ysb_academic_year || semester.academic_year_id,
        ysb_semester_id: semester.id,
        ysb_grade_level_id: form2.ysb_grade_level_id,
        ysb_school_id: form2.ysb_school_id,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_kelas_id: form2.ysb_kelas_id,
      },
      ...fetchParams,
    });

    if (response?.data?.error === true || response?.data?.success === false || response?.data?.status === false || Number(response?.data?.status) >= 400) {
      throw new Error(response?.data?.message || "Gagal memperbarui daftar foto siswa.");
    }

    const groups = Array.isArray(response?.data?.data) ? response.data.data : [];
    const group = groups.find((item) => String(item.ysb_kelas_id) === String(form2.ysb_kelas_id)) || {};
    const refreshed = {
      ...group,
      students: (group.students || []).map((student) => ({
        ...student,
        nama_siswa: student.nama_lengkap || student.nama_siswa || "",
      })),
    };

    // Jangan menimpa data jika user mengganti filter saat GET masih berjalan.
    if (sequence !== requestSequence.current) {
      throw new Error("Filter berubah saat memuat ulang foto.");
    }

    setSemesterDataCache((previous) => ({
      ...previous,
      [String(semester.id)]: refreshed,
    }));
    setDataWalas(refreshed);
    setGetData(refreshed.students);
    return refreshed.students;
  }, [getDataSemesterMap, form2.ysb_semester_id, form2.ysb_branch_id,
    form2.ysb_school_id, form2.ysb_grade_level_id, form2.ysb_kelas_id, fetchParams]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    requestSequence.current += 1;
    setSemesterDataCache({});
    if (name === "name_year") {
      const matching = getDataSemesterMap.filter((semester) => semester?.name_year === value);
      const chosen = matching.find((semester) => semester?.status === 1) ||
        matching.sort((a, b) => Number(a.semester) - Number(b.semester))[0];
      setNamaTA(value);
      setForm2((previous) => ({ ...previous, ysb_semester_id: chosen?.id || "" }));
    } else {
      setForm2((previous) => ({ ...previous, [name]: value }));
    }

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleCari = async () => {
    if (loadingSchool || loadingLevel || loadingKelas) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah, tingkatan, atau kelas masih dimuat.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });
      return;
    }

    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_kelas_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text:
          "Pastikan Semester, Cabang, Sekolah, Tingkatan, dan Kelas sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setGetData([]);
    setDataWalas(null);
    setHasSearched(false);
    setIsFetching(true);
    setSearchKeyword("");

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (error) {
      swal({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const switchSemester = (semester) => {
    if (String(form2.ysb_semester_id) === String(semester.id) || isFetching) return;
    setForm2((previous) => ({ ...previous, ysb_semester_id: semester.id }));
    const cached = semesterDataCache[String(semester.id)] || {};
    setGetData(Array.isArray(cached.students) ? cached.students : []);
    setDataWalas(cached);
    setSearchKeyword("");
    setTablePage(1);
  };


  const studentStatusKey = (student) =>
    `${form2.ysb_semester_id}:${form2.ysb_school_id}:${form2.ysb_kelas_id}:${student?.ysb_student_id ?? student?.id ?? `${student?.nisn || ""}:${student?.nama_siswa || student?.name_student || ""}`}`;
  const studentIsActive = (student) => studentStatuses[studentStatusKey(student)]?.status ??
    (student?.state_form != null
      ? student.state_form === true || Number(student.state_form) === 1
      : String(student?.keterangan_status || "Aktif").trim().toLowerCase() === "aktif");


  const selectedClassName = getDataKelas.find(
    (kelas) => String(kelas.id) === String(form2.ysb_kelas_id)
  )?.name_kelas || "-";
  const selectedLevelName = getDataLevel.find(
    (level) => String(level.id) === String(form2.ysb_grade_level_id)
  )?.name_level || "-";

  const displayedData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];

    const searchValue = safeStr(searchKeyword)
      .trim()
      .toLowerCase();

    if (searchValue) {
      rows = rows.filter((student) => {
        const studentName = safeStr(
          student?.nama_siswa || student?.name_student
        ).toLowerCase();

        const nisn = safeStr(student?.nisn).toLowerCase();

        return (
          studentName.includes(searchValue) ||
          nisn.includes(searchValue)
        );
      });
    }

    rows.sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aHasOrder =
        orderA !== null && !Number.isNaN(orderA);

      const bHasOrder =
        orderB !== null && !Number.isNaN(orderB);

      if (!aHasOrder && bHasOrder) {
        return -1;
      }

      if (aHasOrder && !bHasOrder) {
        return 1;
      }

      if (aHasOrder && bHasOrder && orderA !== orderB) {
        return orderA - orderB;
      }

      const nameA = safeStr(
        a?.nama_siswa || a?.name_student
      );

      const nameB = safeStr(
        b?.nama_siswa || b?.name_student
      );

      const nameComparison = collator.compare(nameA, nameB);

      if (nameComparison !== 0) {
        return nameComparison;
      }

      return collator.compare(
        safeStr(a?.nisn),
        safeStr(b?.nisn)
      );
    });

    return rows;
  }, [collator, getData, searchKeyword]);

  const toTitleCase = (value) => {
    const text = safeStr(value).toLowerCase().trim();

    if (!text) {
      return "";
    }

    return text.replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  };
  const classLabel = `Kelas ${String(selectedLevelName).replace(/^kelas\s+/i, "")} ${toTitleCase(selectedClassName)}`;

  const [dataUpdate, setDataUpdate] = useState();


  const totalRows = displayedData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(
      totalRows / Math.max(1, rowsPerPage)
    );

    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;

    return displayedData.slice(start, start + safeRows);
  }, [displayedData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        pages.push(pageNumber);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (let pageNumber = left; pageNumber <= right; pageNumber++) {
      if (pageNumber !== 1 && pageNumber !== totalPages) {
        pages.push(pageNumber);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const selectedPage = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(selectedPage);
  };

  const viewModalStatus = (id, status) => {
    setModalStatus(true)
    setId(id)
    setDataUpdate(status)
  }

  const handleDetailSaved = useCallback((nextValues, student) => {
    const studentId = student?.ysb_student_id ?? student?.id;

    const updateStudent = (item) => {
      const itemId = item?.ysb_student_id ?? item?.id;
      return String(itemId) === String(studentId)
        ? { ...item, ...nextValues, biodata: { ...(item?.biodata || {}), ...nextValues } }
        : item;
    };

    setGetData((previous) => previous.map(updateStudent));
    setSemesterDataCache((previous) => Object.fromEntries(
      Object.entries(previous).map(([cacheKey, rows]) => [
        cacheKey,
        String(cacheKey) === String(form2.ysb_semester_id) && Array.isArray(rows?.students)
          ? { ...rows, students: rows.students.map(updateStudent) }
          : rows,
      ])
    ));
    setDetailStudent((previous) => previous ? updateStudent(previous) : previous);
    setSuccessToast("Biodata siswa berhasil diperbarui.");
  }, [form2.ysb_semester_id]);

  return (
    <>
      {successToast && (
        <div className="config-success-toast" role="status" aria-live="polite">
          <span className="config-success-toast-icon" aria-hidden="true">✓</span>
          <span>{successToast}</span>
          <div className="config-success-toast-progress" />
        </div>
      )}
      <style>{`
        .config-success-toast{position:fixed;top:38px;right:18px;z-index:20000;display:flex;align-items:center;gap:24px;width:360px;max-width:calc(100vw - 36px);min-height:76px;padding:16px;background:#fff;color:#545454;border-radius:5px;box-shadow:0 4px 10px rgba(0,0,0,.25);font-size:16px;overflow:hidden;pointer-events:none}
        .config-success-toast-icon{display:flex;align-items:center;justify-content:center;width:42px;height:42px;flex-shrink:0;border:4px solid #00d956;border-radius:50%;color:#00d956;font-size:28px;font-weight:700;line-height:1}
        .config-success-toast-progress{position:absolute;left:0;bottom:0;height:4px;background:#ccc;width:100%;transform-origin:left;animation:config-toast-countdown 3s linear forwards}
        @keyframes config-toast-countdown{to{transform:scaleX(0)}}
      `}</style>
    

      <div className="body sims-page">
        {modalStatus && (
          <ModalStatus
            GetResponseData={GetResponseData}
            statusData={getData}
            id={id}
            dataUpdate={dataUpdate}
            isActive={studentIsActive(dataUpdate)}
            onStatusSaved={(value) => {
              const key = studentStatusKey(dataUpdate);
              setStudentStatuses((previous) => ({
                ...previous,
                [key]: { status: value.state_form === 1 },
              }));
              const updateStudent = (student) =>
                studentStatusKey(student) === key
                  ? { ...student, ...value, keterangan_status: value.state_form === 1 ? "Aktif" : "Nonaktif" }
                  : student;
              setGetData((previous) => previous.map(updateStudent));
              setSemesterDataCache((previous) => Object.fromEntries(
                Object.entries(previous).map(([cacheKey, rows]) => [
                  cacheKey,
                  String(cacheKey) === String(form2.ysb_semester_id) && Array.isArray(rows?.students)
                    ? { ...rows, students: rows.students.map(updateStudent) } : rows,
                ])
              ));
            }}
            show={modalStatus}
            onHide={() => setModalStatus(false)}
          />
        )}

        {showImportModal && (
          <ImportExcelModal
            show={true}
            onHide={() => setShowImportModal(false)}
            onImport={(rows) => commitImportedStudents(rows, {
              setGetData, setSemesterDataCache, setTablePage,
              semesterId: form2.ysb_semester_id, currentStudents: getData,
            })}
            context={{ namaTA, selectedClassName, selectedLevelName }}
          />
        )}

        {previewStudent && (
          <PreviewFoto student={previewStudent} show={true} onHide={() => setPreviewStudent(null)} />
        )}

        {detailStudent && (
          <StudentDetailModal
            student={detailStudent}
            onClose={() => setDetailStudent(null)}
            onSave={handleDetailSaved}
          />
        )}

        {modalAdd && (
          <TambahSiswaModal
            show={modalAdd}
            onHide={() => setModalAdd(false)}
            context={{ namaTA, semester: semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.semester, school: getDataSchool.find((item) => String(item.school_code) === String(form2.ysb_school_id))?.school_name }}
            levels={getDataLevel}
            classes={getDataKelas}
            initialLevelId={form2.ysb_grade_level_id}
            initialClassId={form2.ysb_kelas_id}
            apiContext={{
              ysb_academic_year_id: semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.ysb_academic_year_id || semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.ysb_academic_year || semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.academic_year_id,
              ysb_semester_id: form2.ysb_semester_id,
              ysb_branch_id: form2.ysb_branch_id,
              ysb_school_id: form2.ysb_school_id,
            }}
            onSave={async () => {
              await GetResponseData();
              setTablePage(1);
              setModalAdd(false);
              setSuccessToast("Siswa berhasil dimasukkan ke rombel.");
            }}
          />
        )}

  

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faUserGraduate} />
              </span>

              <h4 className="page-title-text">
                Konfigurasi Siswa 
              </h4>
            </div>

            <div className="ml-auto">
              <button
                type="button"
                onClick={() => setModalAdd(true)}
                className="btn btn-create sims-header-button"
              >
                 <FontAwesomeIcon icon={faPlus} />
                <span> Tambah Siswa Baru</span>
              </button>
            </div>

            
          </div>

          <nav
            aria-label="breadcrumb"
            className="sims-breadcrumb-nav mt-4"
          >
            <ol className="sims-breadcrumb">
              <li className="sims-breadcrumb-item">
                <Link to="/data-siswa">Siswa</Link>
              </li>

              <li className="sims-breadcrumb-separator">/</li>

              <li
                className="sims-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Murid Baru
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content sims-content">
          {loading ? (
            <div className="sims-filter-card">
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={`filter-skeleton-${index}`}
                  className="shimmer sims-filter-skeleton"
                />
              ))}
            </div>
          ) : (
            <div className="sims-filter-card">
              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tahun Ajaran
                </label>

                <select
                  className="sims-filter-select"
                  name="name_year"
                  value={namaTA}
                  onChange={handleChange}
                >
                  <option value="" disabled>Pilih Tahun Ajaran</option>
                  {yearOptions.map((year) => (
                    <option key={year.name} value={year.name}>
                      {year.name}{year.active ? " • Aktif" : ""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Cabang
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map((branch, index) => (
                    <option
                      key={branch?.branch_code || index}
                      value={branch?.branch_code}
                    >
                      {branch?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Sekolah
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={
                    loadingSchool ||
                    !form2.ysb_branch_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((school, index) => (
                      <option
                        key={school?.school_code || index}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tingkatan
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_grade_level_id"
                  value={form2.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={
                    loadingLevel ||
                    !form2.ysb_school_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_school_id
                      ? "Pilih Sekolah terlebih dahulu"
                      : loadingLevel
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                  </option>

                  {!loadingLevel &&
                    getDataLevel.map((level, index) => (
                      <option
                        key={level?.id || index}
                        value={level?.id}
                      >
                        {level?.name_level}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Kelas
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_kelas_id"
                  value={form2.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={
                    loadingKelas ||
                    !form2.ysb_grade_level_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_grade_level_id
                      ? "Pilih Tingkatan terlebih dahulu"
                      : loadingKelas
                      ? "Memuat data kelas..."
                      : "Pilih Kelas"}
                  </option>

                  {!loadingKelas &&
                    getDataKelas.map((kelas, index) => (
                      <option
                        key={kelas?.id || index}
                        value={kelas?.id}
                      >
                        {kelas?.name_kelas}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-action">
                <button
                  type="button"
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="sims-filter-button"
                >
                  Tampilkan Data
                </button>
              </div>

              
            </div>
          )}

          {isFetching && (
            <div className="sims-loading">
              <PulseLoader color="#3f5bea" size={12}/>
            </div>
          )}

          {hasSearched && !isFetching && (
            <>
              <div className="sims-main-tabs" role="tablist" aria-label="Data siswa baru">
                {[
                  ["siswa", "Siswa"],
                  ["foto", "Foto Profil"],
                  ["kartu", "Kartu Pelajar"],
                ].map(([key, label]) => (
                  <button key={key} type="button" role="tab"
                    aria-selected={selectedTab === key}
                    className={`sims-main-tab ${selectedTab === key ? "is-active" : ""}`}
                    onClick={() => setSelectedTab(key)}>
                    {label}
                  </button>
                ))}
              </div>

              <div className="sims-table-tab-card">
                
                <div className="sims-table-tab-head d-flex">
                  <div className="sims-table-tab-title">
                    <h5>
                      Kelas {String(getDataLevel.find((level) => String(level.id) === String(form2.ysb_grade_level_id))?.name_level || "-").replace(/^kelas\s+/i, "")}{" "}
                      {toTitleCase(getDataKelas.find((kelas) => String(kelas.id) === String(form2.ysb_kelas_id))?.name_kelas || "")}
                      {selectedTab === "siswa" && <>{" - Semester "}{semesterOptions.find((semester) => String(semester.id) === String(form2.ysb_semester_id))?.semester || "-"}</>}
                    </h5>
                  </div>
                  <div className="sims-table-tab-actions">
                    {selectedTab === "siswa" && <div className="sims-data-actions">
                      <button 
                        onClick={() => setShowImportModal(true)}
                        className="btn btn-create sims-header-button ml-2" 
                      >
                        <FontAwesomeIcon icon={faFileImport} /> 
                        <span> Import Data </span>
                      </button>
                      <button 
                        onClick={() => downloadStudentExcel(
                          getData,
                          { namaTA, selectedClassName, selectedLevelName },
                          semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.semester
                        )}
                        className="btn sims-header-button btn-outline-primary" 
                      >
                        <FontAwesomeIcon icon={faDownload} /> 
                        <span> Download Data </span>
                      </button>
                    </div>}
                    {selectedTab === "siswa" && <div className="sims-table-tab-semester-switch">
                   
                    {semesterOptions.map((semester) => (
                      <button type="button" key={semester.id}
                        className={`sims-table-tab-semester ${String(form2.ysb_semester_id) === String(semester.id) ? "is-active" : ""}`}
                        onClick={() => switchSemester(semester)} disabled={isFetching}>
                        Semester {semester.semester}
                      </button>
                    ))}
                  </div>}
                  </div>
                  
                </div>

                {selectedTab === "siswa" && (
                  <div className="sims-search-wrap mb-3 mt-3 pl-2 pr-2">
                    <FontAwesomeIcon icon={faMagnifyingGlass} className="sims-search-icon" />
                    <input type="text" className="sims-search-input"
                      placeholder="Cari nama siswa atau NISN..."
                      value={searchKeyword}
                      onChange={(event) => setSearchKeyword(event.target.value)} />
                  </div>
                )}
                <div style={{ display: selectedTab === "foto" ? "block" : "none" }}>
                  <FotoProfilTab
                    students={getData}
                    onRefresh={refreshFotoProfil}
                    uploadContext={{
                      ysb_academic_year_id: semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.ysb_academic_year_id || semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.ysb_academic_year || semesterOptions.find((item) => String(item.id) === String(form2.ysb_semester_id))?.academic_year_id,
                      ysb_semester_id: form2.ysb_semester_id,
                      ysb_branch_id: form2.ysb_branch_id,
                      ysb_school_id: form2.ysb_school_id,
                      ysb_grade_level_id: form2.ysb_grade_level_id,
                      ysb_kelas_id: form2.ysb_kelas_id,
                    }}
                    contextKey={`${form2.ysb_semester_id}:${form2.ysb_school_id}:${form2.ysb_kelas_id}`}
                  />
                </div>
                <div style={{ display: selectedTab === "kartu" ? "block" : "none" }}>
                  <KartuPelajarTab
                    students={getData}
                    backgroundImage=""
                    academicYear={namaTA}
                    levelName={selectedLevelName}
                    className={selectedClassName}
                  />
                </div>
                {selectedTab === "siswa" && (
                  <>
                <div className="sims-table-tab-wrap sims-table-scroll">
                <table className="sims-table  sims-table-tab">
                    <thead>
                      <tr>
                        <th className="sims-col-number">
                          No
                        </th>

                         <th style={{width: "100px"}} >
                          Foto
                        </th>

                        <th >
                            Nama Siswa
                        </th>

                        <th style={{width: "150px"}} >
                         NISN
                        </th>

                        <th style={{width: "120px"}}>
                          Jenis Kelamin
                        </th>

                        <th className="text-center">
                          Status
                        </th>

                        <th className="text-center sims-col-action">
                          Aksi 
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={7}
                            className="sims-empty-state"
                          >
                            <div className="sims-empty-state-content">
                              Data murid tidak ditemukan
                            </div>
                          </td>
                        </tr>
                      ) : (
                        paginatedData.map((student, index) => (
                          <tr
                            key={
                              student?.ysb_student_id ||
                              student?.id ||
                              `murid-${index}`
                            }
                          >
                            <td className="sims-col-number">
                              <span className="sims-number-badge">
                                {(tablePage - 1) *
                                  rowsPerPage +
                                  index +
                                  1}
                              </span>
                            </td>

                            <td>
                              <button 
                                type="button" 
                                className="sims-photo-button"
                                title="Klik untuk melihat foto" 
                                onClick={() => setPreviewStudent(student)}
                                aria-label={`Lihat foto ${student?.nama_siswa || student?.name_student || "siswa"}`}
                              >
                                <StudentAvatar photo={studentPhoto(student)} />
                                <span className="sims-photo-zoom" aria-hidden="true">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </span>
                              </button>
                            </td>

                            <td>
                              <span className="sims-text-bold">
                                 {toTitleCase(student?.nama_lengkap) || "-"}
                              </span>
                            </td>

                            <td>
                              <span >
                                {student?.nisn || "-"}
                              </span>
                            </td>

                            <td>
                              <span>
                                {formatJenisKelamin(student?.jenis_kelamin)}
                              </span>
                            </td>

                            <td className="text-center">
                              <button 
                                type="button" 
                                className={`sims-status-badge ${studentIsActive(student) ? "is-active" : "is-inactive"}`} 
                                onClick={() =>
                                        viewModalStatus(
                                          student?.ysb_student_id ?? student?.id,
                                          student
                                        )
                                      }
                                title="Klik untuk ubah status"
                                aria-label={`Ubah status siswa: ${studentIsActive(student) ? "Aktif" : "Tidak Aktif"}`}
                              >
                                <span>{studentIsActive(student) ? "Aktif" : "Tidak Aktif"}</span>
                                <FontAwesomeIcon icon={faPen} className="sims-status-edit-icon" aria-hidden="true" />
                              </button>
                            </td>

                           <td className="text-center">
                            <button
                              type="button"
                              className="sims-table-button"
                              onClick={() => setDetailStudent(student)}
                              title="Detail"
                            >
                              Detail
                            </button>
                          </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {displayedData.length > 0 && (
                  <div className="sims-pagination">
                    <div className="sims-pagination-left">
                      <span className="sims-page-info">
                        Menampilkan{" "}
                        <b>
                          {Math.min(
                            (tablePage - 1) *
                              rowsPerPage +
                              1,
                            totalRows
                          )}
                        </b>
                        -
                        <b>
                          {Math.min(
                            tablePage * rowsPerPage,
                            totalRows
                          )}
                        </b>{" "}
                        dari <b>{totalRows}</b> data
                      </span>

                      <select
                        className="sims-page-size"
                        value={rowsPerPage}
                        onChange={(event) => {
                          const value =
                            Number(event.target.value) || 10;

                          setRowsPerPage(value);
                          setTablePage(1);
                        }}
                      >
                        <option value={10}>
                          10 data / halaman
                        </option>

                        <option value={25}>
                          25 data / halaman
                        </option>

                        <option value={50}>
                          50 data / halaman
                        </option>

                        <option value={100}>
                          100 data / halaman
                        </option>
                      </select>
                    </div>

                    <div className="sims-pagination-right">
                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() =>
                          goToPage(tablePage - 1)
                        }
                        disabled={tablePage <= 1}
                      >
                        Sebelumnya
                      </button>

                      <div className="sims-page-numbers">
                        {pageNumbers.map(
                          (pageNumber, index) =>
                            pageNumber === "..." ? (
                              <span
                                key={`dots-${index}`}
                                className="sims-page-dots"
                              >
                                ...
                              </span>
                            ) : (
                              <button
                                type="button"
                                key={`page-${pageNumber}`}
                                className={`sims-page-number ${
                                  pageNumber === tablePage
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  goToPage(pageNumber)
                                }
                              >
                                {pageNumber}
                              </button>
                            )
                        )}
                      </div>

                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() =>
                          goToPage(tablePage + 1)
                        }
                        disabled={tablePage >= totalPages}
                      >
                        Selanjutnya
                      </button>
                    </div>
                  </div>
                )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
